var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-pic",style:(("background-image:url('" + _vm.backgroundSrc + "'); background-color: " + _vm.backgroundColor))})}
var staticRenderFns = []

export { render, staticRenderFns }